/* Lettoria NEVERMORE SALE — on-page quick view ("claim without leaving the page", True Classic weekly-deals pattern).
 * WHY: Afroyla DD 09-25 — 2,982 card-image clicks exited to PDPs; 378 sessions came back without adding anything.
 * Any [data-lnm-quick="<handle>"] link (shelf card image, Lightning photo) opens a sheet instead of the PDP:
 * photo gallery (scroll-snap), title, price / strike / −%, leather pills, "Claim Faux · $9.95", hold note, "Full details" → PDP.
 * Live data from /products/<h>.js (price, compare, availability, images). Ctrl/⌘/middle clicks still open the PDP.
 * Mobile = bottom sheet (max 88svh), desktop ≥900 px = centered 2-column dialog. Esc / backdrop / × close; focus returns.
 * Keys (store-3 vocabulary): quick-view-open (trigger), quick-view-add, variant-picker, gallery-thumb, x-quick-view-close,
 * collection-card (Full details). Needs window.LNM. */
(function () {
  var A = window.LNM;
  if (!A) return;
  var root = A.root;
  var sheet = root.querySelector('[data-lnm-qv]');
  if (!sheet) return;
  var body = sheet.querySelector('[data-lnm-qv-body]');
  var opener = null;  // element to refocus on close
  var cur = null;     // { p, sel, vars:{id:{name,price,compare,available}} }
  var reqId = 0;

  function open(handle, from) {
    opener = from || null;
    cur = null;
    var id = ++reqId;
    var img = from && from.querySelector('img');
    body.innerHTML = '<div class="lnm-qv__gallery"><div class="lnm-qv__slide">' +
      (img ? '<img src="' + A.esc(img.currentSrc || img.src) + '" alt="">' : '') + '</div></div>' +
      '<div class="lnm-qv__info"><p class="lnm-qv__loading">Loading…</p></div>';
    sheet.hidden = false;
    document.documentElement.classList.add('lnm-qv-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    sheet.querySelector('[data-lnm-qv-close]').focus({ preventScroll: true });
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { if (id === reqId) render(p); })
      .catch(function () { if (id === reqId) location.href = '/products/' + handle; }); // fall back to the PDP
  }

  function close() {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('lnm-qv-lock');
    reqId++;
    setTimeout(function () { sheet.hidden = true; body.innerHTML = ''; }, 200);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  function render(p) {
    var vars = {};
    p.variants.forEach(function (v) { vars[v.id] = { name: v.title, price: v.price / 100, compare: (v.compare_at_price || 0) / 100, available: v.available }; });
    var avail = p.variants.filter(function (v) { return v.available; });
    var pick = (avail.length ? avail : p.variants).reduce(function (m, v) { return v.price < m.price ? v : m; });
    cur = { p: p, sel: pick.id, vars: vars };
    var imgs = (p.images || []).slice(0, 8);
    body.innerHTML =
      '<div class="lnm-qv__gallery" data-qv-gallery>' + imgs.map(function (src, k) {
        return '<div class="lnm-qv__slide"><img src="' + A.esc(A.img(src, 900)) + '" alt="' + A.esc(A.cleanTitle(p.title)) + ' photo ' + (k + 1) + '"' + (k ? ' loading="lazy"' : '') + ' width="900" height="1200"></div>';
      }).join('') + '</div>' +
      (imgs.length > 1 ? '<div class="lnm-qv__dots">' + imgs.map(function (_, k) {
        return '<button type="button" class="lnm-qv__dot' + (k ? '' : ' is-on') + '" data-qv-dot="' + k + '" aria-label="Photo ' + (k + 1) + '" data-hc-el="gallery-thumb"></button>';
      }).join('') + '</div>' : '') +
      '<div class="lnm-qv__info">' +
        '<h3 class="lnm-qv__title" id="lnm-qv-title">' + A.esc(A.cleanTitle(p.title)) + '</h3>' +
        '<p class="lnm-price"><span class="lnm-price__now" data-qv-now></span> <s class="lnm-price__was" data-qv-was></s> <span class="lnm-qv__off" data-qv-off></span></p>' +
        (p.variants.length > 1 ? '<div class="lnm-vars" role="radiogroup" aria-label="Leather" data-qv-vars></div>' : '') +
        '<button type="button" class="lnm-btn lnm-btn--big" data-qv-add data-hc-el="quick-view-add"></button>' +
        '<p class="lnm-ld__note">Your price holds in your cart until ' + A.esc(A.whenLabel(A.END - 60000)) + '. Stock isn&#39;t held.</p>' +
        '<a class="lnm-qv__pdp" href="/products/' + A.esc(p.handle) + '" data-hc-el="x-sheet-pdp-link">Full details →</a>' +
      '</div>';
    paint();
  }

  function paint() {
    var v = cur.vars[cur.sel];
    var ids = cur.p.variants.map(function (x) { return x.id; });
    var labels = A.variantLabels(cur.p.variants.map(function (x) { return x.title; }), true);
    var off = A.pct(v.price, v.compare);
    body.querySelector('[data-qv-now]').textContent = A.money(v.price);
    body.querySelector('[data-qv-was]').textContent = v.compare > v.price ? A.money(v.compare) : '';
    body.querySelector('[data-qv-off]').textContent = off ? '−' + off + '%' : '';
    var btn = body.querySelector('[data-qv-add]');
    if (!btn.classList.contains('is-added')) {
      btn.disabled = !v.available;
      btn.textContent = !v.available ? 'Sold out' : ids.length > 1 ? 'Claim ' + labels[ids.indexOf(cur.sel)] + ' · ' + A.money(v.price) : 'Claim · ' + A.money(v.price);
    }
    var wrap = body.querySelector('[data-qv-vars]');
    if (!wrap) return;
    wrap.innerHTML = cur.p.variants.map(function (x, k) {
      var o = cur.vars[x.id];
      return '<button type="button" role="radio" class="lnm-var' + (x.id === cur.sel ? ' is-on' : '') + '" aria-checked="' + (x.id === cur.sel) + '"' +
        (o.available ? '' : ' disabled') + ' data-qv-v="' + x.id + '" data-hc-el="variant-picker">' + A.esc(labels[k]) + ' <b>' + A.money(o.price) + '</b></button>';
    }).join('');
  }

  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-lnm-qv-close]') || e.target === sheet) { close(); return; }
    var pill = e.target.closest('[data-qv-v]');
    if (pill && cur) { cur.sel = Number(pill.dataset.qvV); paint(); return; }
    var add = e.target.closest('[data-qv-add]');
    if (add && cur && cur.vars[cur.sel].available) {
      var first = cur.p.images && cur.p.images[0];
      A.runAdd(add, cur.sel, first ? A.img(first, 300) : '').then(function () { if (cur) paint(); });
      return;
    }
    var dot = e.target.closest('[data-qv-dot]');
    if (dot) {
      var g = body.querySelector('[data-qv-gallery]');
      g.scrollTo({ left: g.clientWidth * Number(dot.dataset.qvDot), behavior: 'smooth' });
    }
  });
  // gallery dots follow the swipe
  sheet.addEventListener('scroll', function (e) {
    var g = e.target;
    if (!g.matches || !g.matches('[data-qv-gallery]')) return;
    var k = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
    sheet.querySelectorAll('[data-qv-dot]').forEach(function (d, i) { d.classList.toggle('is-on', i === k); });
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });

  // triggers anywhere on the page (cards are re-rendered, so delegate from root)
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lnm-quick]');
    if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    open(a.dataset.lnmQuick, a);
  });
})();
